<template>
    <AppModal :name="modalName"
              :tabindex="2"
              :onEnterKeyPress="onProcessInit"
              :beforeOpen="beforeOpen"
              :beforeClose="clearPassword">
        <template v-slot:header>
            {{ title }}
        </template>
        <template v-slot:content>
            <div>
                {{ description }}
            </div>
            <div class="row justify-content-center mt-4">
                <div class="col-8 text-left">
                    <label>
                        Account password
                    </label>
                    <AppPasswordInput
                        v-model="password"
                        placeholder="Current password"
                        id="current-password"/>
                </div>
            </div>
        </template>
        <template v-slot:actions>
            <div class="text-right">
                <button @click="cancelAction" class="btn btn-link mt-3">
                    Cancel
                </button>
                <button v-loading.btn="isLoading" @click="onProcessInit" class="btn btn-primary">
                    Proceed
                </button>
            </div>
        </template>
    </AppModal>
</template>

<script>
import AppModal from '../../components/shared/AppModal'
import {showErrorMessage} from '@/services/snackbar'
import AppPasswordInput from '@/components/shared/AppPasswordInput.vue'

export default {
    name: 'AccountPasswordConfirmationModal',
    components: {AppPasswordInput, AppModal},
    props: {
        modalName: {
            type: String,
            default: 'account-password-confirmation-modal'
        }
    },
    data() {
        return {
            title: null,
            description: null,
            onConfirm: null,
            onCancel: null,

            password: '',
            isLoading: false
        }
    },
    methods: {
        beforeOpen({params}) {
            this.title = params.title || 'Account confirmation required'
            this.description = params.description || 'Please enter your password to confirm you wish to perform this action'
            this.onConfirm = params.onConfirm
            this.onCancel = params.onCancel
        },

        async onProcessInit() {
            if (!this.password) {
                showErrorMessage('Please enter your password')
                return
            }
            if (typeof this.onConfirm !== 'function') {
                showErrorMessage('Something went wrong')
                return
            }
            this.isLoading = true
            await this.onConfirm(this.password)
            this.isLoading = false
            this.closeModal()
        },

        clearPassword() {
            this.password = ''
        },

        cancelAction() {
            if (typeof this.onCancel === 'function') {
                this.onCancel()
            }
            this.closeModal()
        },

        closeModal() {
            this.$modal.hide(this.modalName)
        }
    }
}
</script>

<style scoped lang="scss">
button {
    width: 140px;
}
</style>
